export {default} from './ProgressBarContent';
